import { Box, Button, useTheme } from '@mui/material'
import React, { useContext, useState, useEffect } from 'react'
import Header from '../../../../components/Header'
import { UserContext } from '../../../../context/UserContext'
import RefCodeBox from '../../../../components/RefCodeBox'
import { tokens } from '../../../../theme'
import axios from 'axios'
import AddRefCodeDialog from '../../../../components/AddRefCodeDialog'


function RefCodes() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { token, user } = useContext(UserContext);
  const [refCodes, setRefCodes] = useState([]);

  useEffect(() => {
    fetchRefCodes();
  }, []);

  const fetchRefCodes = () => {
    axios.get(`${process.env.REACT_APP_API_URL}api/alcago/brand/getBrandRefCodes?token=${token}&brandId=${user.id}`)
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 200) {
          setRefCodes(response.data.refCodes);
        }
      });
  }

  const [open, setOpenDialog] = useState(false);

  return (
    <Box mt="20px">
      <AddRefCodeDialog
        open={open}
        onClose={() => { fetchRefCodes(); setOpenDialog(false); }}
        onCreated={() => { fetchRefCodes(); setOpenDialog(false); }}
        token={token}
        checkPath="user"
        createPath="brand"
        ownerField="brand_id"
        ownerId={user.id}
      />
      <Box ml="20px" display="flex" alignItems="center">
        <Header title="Referans Kodları" subtitle="Referans kodlarınızı görüntüleyebilir ve yeni kod oluşturabilirsiniz." />
        <Button variant='contained' color='success' sx={{ ml: "30px" }} onClick={() => setOpenDialog(true)}>Yeni Ekle</Button>
      </Box>
      <Box>
        {refCodes.map((refCode, i) =>
          <Box key={i} display="inline-block" p="20px">
            <RefCodeBox refCode={refCode} type={"influencer_brand"} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default RefCodes;